import { useMemo } from 'react';
import { useDesignsContext } from '@/shared/providers/DesignsProvider';
import filterPersonEntities from '@/shared/utils/filterPersonEntities';
import useAuthStore from '@pkg/auth/useStore';
import * as Sort from '@pkg/utils/sort';
import { DesignType } from '@/lib/enums';

export default function useUserRelatedEntities(liveDesignsOnly = false) {
  const me = useAuthStore((state) => state.me);
  const personId = useAuthStore((state) => state.me?.person?.uuid ?? null);
  const designs = useDesignsContext();

  return useMemo(() => {
    const out = {
      designs: [],
      groups: [],
      roles: [],
    };

    if (designs?.isLoading || !designs?.designs?.size) {
      return out;
    }

    if (Boolean(designs.designs.size > 0) && personId) {
      // Filter out scenarios if we only want live designs.
      const allowedDesigns = liveDesignsOnly
        ? new Map(
            [...designs.designs.entries()].filter(([_, { design }]) => {
              return design.type === DesignType.LIVE;
            })
          )
        : designs.designs;

      const ids = {
        uuid: personId,
        id: me.id,
      };

      const entities = filterPersonEntities(
        allowedDesigns,
        designs?.supporterMap,
        ids
      );

      const isScenarioSort = Sort.bool('__isScenario', true);
      out.designs = Array.from(entities?.designs.values()).sort(isScenarioSort);
      out.groups = Array.from(entities?.groups.values()).sort(isScenarioSort);
      out.roles = Array.from(entities?.roles.values()).sort(isScenarioSort);
    }

    return out;
  }, [designs?.designs, designs?.supporterMap, personId, designs?.isLoading]);
}
